import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Environment, EnvironmentService } from '@galaxy/core';
import { TranslateModule } from '@ngx-translate/core';
import { And, Rule, RuleInterface } from '@vendasta/automata';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import * as BillingParameterSKU from '../billing-paramater-sku';
import * as BillingParameterApproved from '../billing-parameter-approved';
import { ApprovalState } from '../billing-parameter-approved';
import { excludedSKUsDemo, excludedSKUsProd } from '../billing-purchase-success.constants';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-billing-purchase-success-panel',
  templateUrl: './billing-purchase-success-panel.component.html',
  styleUrls: ['./billing-purchase-success-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
  ],
})
export class BillingPurchaseSuccessPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  skusToExclude: string[];
  approvalControl: UntypedFormControl;
  approvalOptions: SelectInputOptionInterface[] = [
    {
      label: 'AUTOMATIONS.EDITOR.TRIGGERS.COMMON.ANY',
      value: ApprovalState.ANY,
    },
    {
      label: 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.APPROVAL_STATES.APPROVED',
      value: ApprovalState.APPROVED,
    },
    {
      label: 'AUTOMATIONS.EDITOR.TRIGGERS.BILLING_PURCHASE.APPROVAL_STATES.NOT_APPROVED',
      value: ApprovalState.NOT_APPROVED,
    },
  ];

  constructor(private readonly environmentService: EnvironmentService) {
    super();
    const env = environmentService.getEnvironment();
    this.skusToExclude = env === Environment.PROD ? excludedSKUsProd : excludedSKUsDemo;
    this.approvalControl = new UntypedFormControl(ApprovalState.ANY);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.triggerChoices?.rules?.length > 0) {
      const rule = Rule.fromRuleInterface(this.triggerChoices.rules[0]) as And;
      const approvedRule = rule.listValuesByVariablePath(BillingParameterApproved.path());

      if (approvedRule.length === 2) {
        this.approvalControl.setValue(ApprovalState.ANY);
      } else if (approvedRule[0] === true) {
        this.approvalControl.setValue(ApprovalState.APPROVED);
      } else {
        this.approvalControl.setValue(ApprovalState.NOT_APPROVED);
      }
    }

    this.savingEnabled$.next(true);
  }

  isFormValid(): boolean {
    return true;
  }

  getBaseRules(): RuleInterface[] {
    const excludedSKUsRule = BillingParameterSKU.rule(this.skusToExclude);

    const rules: Rule[] = [excludedSKUsRule];
    const approvedRule = BillingParameterApproved.rule(this.approvalControl.value);
    rules.push(approvedRule);

    const and = new And(rules, '');
    return [and.toRuleInterface()];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    const rule = this.getBaseRules();
    rule[0].next = rules[0].next;
    return rule;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }
}
